import React, { useEffect, useState } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { Autocomplete, Button, TextField } from "@mui/material";
import UpdateIcon from "@mui/icons-material/Update";
import { GetKey } from "../../../Helpers/GetKey";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { TotalizarByProp } from "../../../Helpers/Agrupaciones/TotalizarByProp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { LoaderScreen } from "../../components/LoaderScreen";

export default function PagaresListScreen() {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [documentos, setDocumentos] = useState([]);
  const [arraySucursales, setArraySucursales] = useState([]);

  const [state, setState] = useState({
    filtro: "",
    sucursal: "",
  });
  useEffect(() => {
    setLoader({
      ...loader,
      mostrar: true,
    });

    request
      .get(`Sucursales/Listado`)
      .then((result) => {
        setArraySucursales(result);
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("REGISTRO DE PAGARES", JSON.stringify(error), "info");
      });
  }, []);
  const onActualizar = () => {
    if (
      state.filtro === undefined ||
      state.filtro === null ||
      state.filtro === "" ||
      state.sucursal === undefined ||
      state.sucursal === null ||
      state.sucursal === ""
    ) {
      return;
    }
    setLoader({
      ...loader,
      mostrar: true,
    });
    request
      .get(
        `FacturacionSinFolio/FacturasSinFolio?filtro=${
          state.filtro
        }&sucursal=${GetKey(state.sucursal)}`
      )
      .then((result) => {
        setDocumentos(result);
        setLoader({
          ...loader,
          mostrar: false,
        });
      })
      .catch((error) => {
        setLoader({
          ...loader,
          mostrar: false,
        });
        Swal.fire({
          icon: "error",
          title: "REGISTRO DE PAGARES",
          text: JSON.stringify(error),
        });
      });
  };
  return (
    <div className="credito-pagares">
      <LoaderScreen loader={loader} />

      <div className="credito-pagares-titulo">
        <div
          className="credito-pagares-titulo-back"
          onClick={() => history.push("/Credito/Main")}
        >
          <ArrowBackIcon /> REGRESAR
        </div>
        REGISTRO DE PAGARES
      </div>
      <div className="credito-pagares-controls">
        <Autocomplete
          size="small"
          fullWidth
          disablePortal
          id="filtrado-facturas"
          value={state.sucursal}
          className="auto-complete-12 "
          onChange={(event) =>
            setState({ ...state, sucursal: event.target.outerText })
          }
          options={arraySucursales.map(
            (item) => `${item.idsucursal} - ${item.sucursal}`
          )}
          sx={{ mr: 1 }}
          renderInput={(params) => <TextField {...params} label="Sucursal" />}
          color="success"
        />
        <Autocomplete
          size="small"
          fullWidth
          disablePortal
          id="filtrado-facturas"
          className="icono-textbox auto-complete-12 MuiAutocomplete-popper"
          onChange={(event) =>
            setState({ ...state, filtro: event.target.outerText })
          }
          options={["TODOS", "REGISTRADOS", "SIN REGISTRO"].map(
            (item) => `${item}`
          )}
          renderInput={(params) => <TextField {...params} label="Filtrar" />}
          color="success"
          sx={{ mr: 1 }}
        />
        <Button
          size="small"
          variant="outlined"
          color="success"
          onClick={() => onActualizar()}
        >
          <UpdateIcon />
        </Button>
      </div>
      <div className="credito-pagares-table scroll-4">
        {documentos === undefined ||
        documentos === null ||
        documentos.length === 0 ? (
          <div></div>
        ) : (
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Region</th>
                <th>
                  <div>Sucursal</div>
                </th>
                <th>
                  <div>Modulo</div>
                </th>
                <th>
                  <div># Cliente</div>
                </th>
                <th>
                  <div>Razon Social</div>
                </th>
                <th>
                  <div>Documento</div>
                </th>
                <th>
                  <div>Fecha</div>
                </th>
                <th>
                  <div>Vencimiento</div>
                </th>
                <th>
                  <div>Importe</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {documentos.map((item) => (
                <tr
                  onClick={() =>
                    history.push(
                      "/Credito/pagareSaveChanges",
                      item
                    )
                  }
                >
                  <td className={`registrado-${item.registrado}`}>
                    {item.adr}{" "}
                  </td>
                  <td>{item.sucursal}</td>
                  <td>{item.modulo}</td>
                  <td>{item.idcliente}</td>
                  <td>{item.razonsocial}</td>
                  <td>{item.documento}</td>
                  <td>{item.fecha}</td>
                  <td>{item.vencimiento}</td>
                  <td>{FormatMoney(item.importe)}</td>
                  {/* <td> */}
                  {/* <ModalScreen
                      button={{
                        text: "Factura",
                        id: "button-agregar-2",
                      }}
                    >
                      <GuardarFacturasinFolioScreen
                        data={item}
                        onActualizar={onActualizar}
                      />
                    </ModalScreen> */}
                  {/* </td> */}
                  {/* <td><BookmarkRemoveIcon /> </td> */}
                </tr>
              ))}
              <tr className="totalizar">
                <td colSpan={8}>TOTAL:</td>
                <td>{FormatMoney(TotalizarByProp(documentos, "importe"))}</td>
                <td></td>
                {/* <td></td> */}
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
